import React, { useState } from "react";
import { Input, message, notification, Spin } from "antd";
import { create_upload_document_actionHandler } from "../../../../../Redux/Actions/user/CreateUploadDocument";
import { useDispatch, useSelector } from "react-redux";
const UploadDocuments = () => {
  const [document, setDocument] = useState(null);
  const [name, setName] = useState("");
  const [nameTouched, setNameTouched] = useState(false);
  const [documentTouched, setDocumentTouched] = useState(false);
  let dispatch = useDispatch();
  const loading = useSelector((state) => state.create_video_guide_data.loader);

  const loaderUpload = useSelector(
    (state) => state.create_upload_documents_data
  );

  const handleFileChangeMenu = (e) => {
    const file = e.target.files[0];
    setDocument(file);
    setDocumentTouched(true);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];

    if (file && isDocumentFile(file)) {
      setDocument(file);
      setDocumentTouched(true);
    } else {
      alert("Please drop a valid document file .");
    }
  };
  const isDocumentFile = (file) => {
    const validTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "text/plain",
    ];
    return validTypes.includes(file.type);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    setNameTouched(true);
    setDocumentTouched(true);

    if (!(name ?? "").trim()) {
      notification.error({ message: "Please enter a document title." });
      return;
    }

    if (!document) {
      notification.error({ message: "Please select a document file." });
      return;
    }

    const allowedFileTypes = [
      "pdf",
      "jpg",
      "jpeg",
      "png",
      "mp4",
      "mov",
      "avi",
      "docx",
      "xlsx",
    ];
    const fileType = document.type.split("/")[1];

    if (!allowedFileTypes.includes(fileType)) {
      notification.error({ message: "Please select a valid file type." });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("file", document);

      dispatch(create_upload_document_actionHandler(formData));
      if (loaderUpload.error) {
        message.error("Something went wrong");
      } else {
        message.success("Document uploaded successfully");
      }
      setName("");
      setDocument("");
      setNameTouched(false);
      setDocumentTouched(false);
    } catch (error) {
      console.error("Error uploading document:", error);
    }
  };

  return (
    <div className="main-cont-up">
      <div>
        <form className="faqForm">
          <div className="workspaces-input-field">
            <label>Document Title</label>
            <Input
              placeholder="Sample"
              value={name}
              required
              onChange={(e) => setName(e.target.value)}
              onBlur={() => setNameTouched(true)}
            />
            {nameTouched && !name.trim() && (
              <p className="validation-message">
                Please enter a document title.
              </p>
            )}
          </div>

          <div
            className="drag-drop mt-22"
            onDragOver={handleDragOver}
            onDrop={handleDrop}
          >
            <div className="stick">
              <p>
                Drag & Drop Your file or click to upload your Document (PDF or
                avi files)
              </p>
              <span>Or</span>
              <div className="file-uploader2">
                <label htmlFor="fileInputDocument" className="file-label">
                  <svg
                    className="upload-svg"
                    width="17"
                    height="18"
                    viewBox="0 0 17 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.25 12.75V8.25L4.75 9.75"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6.25 8.25L7.75 9.75"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16 7.5V11.25C16 15 14.5 16.5 10.75 16.5H6.25C2.5 16.5 1 15 1 11.25V6.75C1 3 2.5 1.5 6.25 1.5H10"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M16 7.5H13C10.75 7.5 10 6.75 10 4.5V1.5L16 7.5Z"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  Upload form computer
                </label>
                <input
                  type="file"
                  id="fileInputDocument"
                  onChange={handleFileChangeMenu}
                  required
                  onBlur={() => setDocumentTouched(true)}
                />
                {document && <span className="file-name">{document.name}</span>}
              </div>
            </div>
          </div>
          {documentTouched && !document && (
            <p className="validation-message">Please select a Document file.</p>
          )}

          <div className="upload">
            <button
              type="submit"
              className="upload-button"
              onClick={handleUpload}
              disabled={loading}
            >
              Upload Document
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default UploadDocuments;
